/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Students_AddingInputs */

const en_students_adding = /** @type {(inputs: Students_AddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding...`)
};

const he_students_adding = /** @type {(inputs: Students_AddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוסיף...`)
};

/**
* | output |
* | --- |
* | "Adding..." |
*
* @param {Students_AddingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const students_adding = /** @type {((inputs?: Students_AddingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Students_AddingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_students_adding(inputs)
	return he_students_adding(inputs)
});